module.exports = __webpack_public_path__ + "img/xjxq.f35efeac.jpg";